module.exports = __webpack_public_path__ + "img/system11-details.9bff8179.png";